/**
 * Legal API — DISCLAIMER-01
 *
 * Thin wrappers over `apiRequest`, which already unwraps the envelope and
 * attaches CSRF on the mutation. This module has no `meta` to preserve.
 */

import { apiRequest } from '@/lib/queryClient';
import type { SupportedLocale } from '@/i18n';
import type {
  AcceptDisclaimerInput,
  Disclaimer,
  DisclaimerAcceptance,
} from '../types/legal.types';

export const DISCLAIMER_ENDPOINT = '/api/legal/disclaimer';

export function fetchDisclaimer(locale: SupportedLocale): Promise<Disclaimer> {
  return apiRequest<Disclaimer>(`${DISCLAIMER_ENDPOINT}?locale=${locale}`);
}

export function acceptDisclaimer(payload: AcceptDisclaimerInput): Promise<DisclaimerAcceptance> {
  return apiRequest<DisclaimerAcceptance>(`${DISCLAIMER_ENDPOINT}/accept`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
